import React from 'react'
import CardContainer from './CardContainer'
import NextImage from '../images/NextImage'
import Styling from '../../styling'
import MomentFormatter from '../../formatters/MomentFormatter'
import PillDefault from '../pills/PillDefault'
import Bookmark from '@/library/entities/bookmarks/Bookmark'
import { COUNTRY_UAE_ID } from '@/data/constants'

export default function CardWImage(props) {
  const {
    item = {},
    body,
    preHeading,
    preHeadingImage,
    preHeadingImageAlt,
    heading,
    headingSize = "heading3",
    tag,
    date,
    image,
    imageAlt,
    imageColSpan = 4,
    bodyPaddingX = 4,
    bodyPaddingY = 8,
    isCard,
    showBookmark = true,
    countryId = COUNTRY_UAE_ID
  } = props

  const totalSpan = 10
  const bodyColSpan = totalSpan - imageColSpan

  const renderBookmark = () => {
    return showBookmark && item.pk ? (
      <Bookmark
        appName={'publications'}
        modelName={'editorialcontent'}
        entityId={item.pk}
        countryId={countryId}
      />
    ) : null
  }

  const renderBody = () => {
    return (
      <div className={`grid grid-cols-1 lg:grid-cols-${totalSpan} gap-0 lg:gap-0 h-full`}>
        {image && (
          <NextImage
            className={`col-span-1 lg:col-span-${imageColSpan} w-full h-full min-h-72 lg:min-h-full`}
            src={image}
            width={800}
            alt={imageAlt}
            style={{ objectFit: 'cover' }}
          />
        )}
        <div className={`col-span-1 lg:col-span-${bodyColSpan} px-${bodyPaddingX} py-${bodyPaddingY}`}>
          <div className="grid grid-cols-1 gap-4">
            {(preHeading || preHeadingImage) && (
              <div>
                {preHeadingImage && (
                  <div className="mb-2">
                    <NextImage
                      src={preHeadingImage}
                      height="20"
                      width="50"
                      className="rounded-md inline-block grayscale opacity-70"
                      alt={preHeadingImageAlt}
                      style={{ objectFit: 'contain' }}
                    />
                  </div>
                )}
                {preHeading && (
                  <div className={`${Styling.sizes.xsWide.strong} text-secondary-900`}>
                    {preHeading}
                  </div>
                )}
              </div>
            )}

            <div>

              {tag && (
                <p className={`${Styling.sizes.wide.default} uppercase`}>
                  {tag}
                </p>
              )}
              {heading && (
                <h2 className={`${Styling.sizes[headingSize].default}`}>
                  {heading}
                </h2>
              )}
            </div>

            {body && (
              <div className={`${Styling.sizes.body.default}`}>
                {body}
              </div>
            )}
            <div className="flex flex-col gap-4">

              {date && (
                <MomentFormatter
                  className={`${Styling.sizes.xs.default}`}
                  date={date}
                  fromNow
                />
              )}
              {renderBookmark()}
            </div>
          </div>
        </div>

      </div>
    )
  }

  return (
    <>
      <CardContainer
        className={`h-full ${Styling.backgrounds.light}`}
        isCard={isCard}
        rounded={false}
        body={renderBody()}
      />
    </>
  )
}
